import script from "./CookieDeclaration.vue?vue&type=script&setup=true&lang=js"
export * from "./CookieDeclaration.vue?vue&type=script&setup=true&lang=js"

import "./CookieDeclaration.vue?vue&type=style&index=0&id=f4022f96&lang=scss"

const __exports__ = script;

export default __exports__